export default __webpack_public_path__ + "static/media/AINQA_Logo-WHITE.5dadf018.svg";